import React from "react";
import { Card, Checkbox } from "@fluentui/react-components";
import { ResultTypes } from "../Results";
import { DebitosFederaisCardProps } from "./DebitosFederaisCard.types";

export default function DebitosFederaisCard({
  state: { isChecked },
  setState,
}: DebitosFederaisCardProps) {
  return (
    <Card>
      <Checkbox
        checked={isChecked}
        onChange={(_, data) => setState({ isChecked: !!data.checked })}
        label={<b>{ResultTypes.government_debtors.label}</b>}
      />
    </Card>
  );
}
